// ============================================================
// UseYn filter options

// ============================================================
export const ALL_OPTION = 'ALL';
export const USE_YN_OPTIONS = (t) => [
  { value: ALL_OPTION, label: t('annualLeaveException.all') },
  { value: 'Y', label: t('commonCodeSetting.used') },
  { value: 'N', label: t('commonCodeSetting.unused') },
];

export const ETC_INPUT_TYPE_OPTIONS = (t) => [
  { value: 'DIRECT', label: t('commonCodeSetting.additionInputType.directInput') },
  { value: 'CODE', label: t('shiftManagement.code') },
  { value: 'CALENDAR', label: t('commonCodeSetting.additionInputType.calendar') },
];

export const ETC_SERL_OPTIONS = (t) =>
  Array.from({ length: 15 }, (_, index) => ({
    value: index + 1,
    label: t(`commonCodeSetting.etc${index + 1}`),
  }));

// ============================================================
// Empty row templates for new row creation
// ============================================================
export const EMPTY_COMMON_CODE = {
  id: '',
  commCodeType: '',
  commCodeName: '',
  commCodeDesc: '',
  useYn: 'Y',
};

export const EMPTY_DETAIL_CODE = {
  mstId: 0,
  commCodeName: '',
  commCodeNameEng: '',
  commCodeNameVie: '',
  commCodeNameChn: '',
  commCodeDesc: '',
  startDate: null,
  endDate: null,
  sortNo: 0,
  etc1: '',
  etc2: '',
  etc3: '',
  etc4: '',
  etc5: '',
  etc6: '',
  etc7: '',
  etc8: '',
  etc9: '',
  etc10: '',
  etc11: '',
  etc12: '',
  etc13: '',
  etc14: '',
  etc15: '',
};

export const EMPTY_ATTRIBUTE = {
  etcSerl: 1,
  etcInputType: '',
  etcInputTypeCd: '',
  etcName: '',
};
